/** Mono int16 little-endian PCM as -1..1 samples (a trailing odd byte is left out). */
export function pcm16(bytes: ArrayBuffer): Float32Array<ArrayBuffer> {
  const v = new DataView(bytes);
  const out = new Float32Array(Math.floor(bytes.byteLength / 2));
  for (let i = 0; i < out.length; i++) out[i] = v.getInt16(i * 2, true) / 0x8000;
  return out;
}

/** Mono int16 PCM out of a WAV file (the TTS's, the held sounds'), as -1..1 samples. Anything else is refused. */
export function pcmOfWav(bytes: ArrayBuffer): { pcm: Float32Array<ArrayBuffer>; rate: number } {
  const v = new DataView(bytes);
  const tag = (o: number) => String.fromCharCode(v.getUint8(o), v.getUint8(o + 1), v.getUint8(o + 2), v.getUint8(o + 3));
  if (bytes.byteLength < 12 || tag(0) !== 'RIFF' || tag(8) !== 'WAVE') throw new Error('not a WAV file');
  let rate = 0;
  for (let o = 12; o + 8 <= bytes.byteLength; ) {
    const id = tag(o);
    const size = v.getUint32(o + 4, true);
    if (id === 'fmt ') {
      if (v.getUint16(o + 8, true) !== 1 || v.getUint16(o + 10, true) !== 1 || v.getUint16(o + 22, true) !== 16) {
        throw new Error('the WAV is not mono int16 PCM');
      }
      rate = v.getUint32(o + 12, true);
    }
    if (id === 'data') {
      if (!rate) throw new Error('the WAV has its data before its format');
      return { pcm: pcm16(bytes.slice(o + 8, o + 8 + Math.min(size, bytes.byteLength - o - 8))), rate };
    }
    o += 8 + size + (size % 2);
  }
  throw new Error('the WAV has no data');
}
